import { apiClient } from "../../../base/ApiClient";

export const createBedRailAssessment = async (formData) => {
  const response = await apiClient.post("/assessments/bed-rail-answers/", formData);
  return response;
};

export const getBedRailAssessments = async (clientId) => {
  const response = await apiClient.get("/assessments/bed-rail-answers/", {
    params: { client: clientId },
  });
  return response;
};

export const getBedRailQuestions = async () => {
  const response = await apiClient.get("/assessments/bed-rail-questions/");
  return response.data;
};